exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-by-collections .badge {\n  border-radius: 0.25rem;\n  margin-right: 5px;\n  cursor: pointer;\n  font-size: 100%;\n  margin-bottom: 3px;\n}\n.filter-by-collections .badge-outline-primary {\n  color: var(--blue);\n  border: 1px solid var(--blue);\n}\n.filter-by-collections .badge-outline-primary:hover {\n  color: white;\n  background-color: var(--blue);\n}", ""]);

// exports
